// @generated by protoc-gen-es v2.2.3 with parameter "target=ts,ts_nocheck=true"
// @generated from file einride/rd_operator_interface/v1/remote_interface_action.proto (package einride.rd_operator_interface.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { Path } from "./path_pb";
import { file_einride_rd_operator_interface_v1_path } from "./path_pb";
import { file_google_api_field_behavior } from "../../../google/api/field_behavior_pb";
import { file_google_api_resource } from "../../../google/api/resource_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file einride/rd_operator_interface/v1/remote_interface_action.proto.
 */
export const file_einride_rd_operator_interface_v1_remote_interface_action: GenFile = /*@__PURE__*/
  fileDesc("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", [file_einride_rd_operator_interface_v1_path, file_google_api_field_behavior, file_google_api_resource, file_google_protobuf_timestamp]);

/**
 * RemoteInterfaceAction is used for sending action requests to the RI.
 *
 * @generated from message einride.rd_operator_interface.v1.RemoteInterfaceAction
 */
export type RemoteInterfaceAction = Message<"einride.rd_operator_interface.v1.RemoteInterfaceAction"> & {
  /**
   * Pattern: remoteInterfaces/{remoteInterface}, where {remoteInterface} is a base32-encoded UUID.
   *
   * @generated from field: string remote_interface = 1;
   */
  remoteInterface: string;

  /**
   * Pattern: vehicles/{vehicleId}, where {vehicleId} is a base32-encoded UUID.
   *
   * @generated from field: string vehicle = 2;
   */
  vehicle: string;

  /**
   * The requesting user field contains the UID of the user requesting the action. The field is used
   * to ensure only the user that requested the initial action is able to execute new actions in the current session.
   *
   * @generated from field: string requesting_user = 3;
   */
  requestingUser: string;

  /**
   * @generated from oneof einride.rd_operator_interface.v1.RemoteInterfaceAction.action
   */
  action: {
    /**
     * Request to establish a connection between RI and AV.
     *
     * @generated from field: einride.rd_operator_interface.v1.RemoteInterfaceAction.ConnectAction connect = 4;
     */
    value: RemoteInterfaceAction_ConnectAction;
    case: "connect";
  } | {
    /**
     * Request to terminate a connection between RI and AV.
     *
     * @generated from field: einride.rd_operator_interface.v1.RemoteInterfaceAction.DisconnectAction disconnect = 5;
     */
    value: RemoteInterfaceAction_DisconnectAction;
    case: "disconnect";
  } | {
    /**
     * Request to assign a path to the connected AV.
     *
     * @generated from field: einride.rd_operator_interface.v1.RemoteInterfaceAction.AssignPathAction assign_path = 6;
     */
    value: RemoteInterfaceAction_AssignPathAction;
    case: "assignPath";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message einride.rd_operator_interface.v1.RemoteInterfaceAction.
 * Use `create(RemoteInterfaceActionSchema)` to create a new message.
 */
export const RemoteInterfaceActionSchema: GenMessage<RemoteInterfaceAction> = /*@__PURE__*/
  messageDesc(file_einride_rd_operator_interface_v1_remote_interface_action, 0);

/**
 * Request to establish a connection between RI and AV.
 *
 * @generated from message einride.rd_operator_interface.v1.RemoteInterfaceAction.ConnectAction
 */
export type RemoteInterfaceAction_ConnectAction = Message<"einride.rd_operator_interface.v1.RemoteInterfaceAction.ConnectAction"> & {
  /**
   * Remote operation sw version on vehicle.
   *
   * @generated from field: string version = 1;
   */
  version: string;

  /**
   * Display name of the vehicle, used for DNS lookup in Gen2 VPN.
   *
   * @generated from field: string vehicle_display_name = 2;
   */
  vehicleDisplayName: string;
};

/**
 * Describes the message einride.rd_operator_interface.v1.RemoteInterfaceAction.ConnectAction.
 * Use `create(RemoteInterfaceAction_ConnectActionSchema)` to create a new message.
 */
export const RemoteInterfaceAction_ConnectActionSchema: GenMessage<RemoteInterfaceAction_ConnectAction> = /*@__PURE__*/
  messageDesc(file_einride_rd_operator_interface_v1_remote_interface_action, 0, 0);

/**
 * Request to terminate a connection between RI and AV.
 *
 * @generated from message einride.rd_operator_interface.v1.RemoteInterfaceAction.DisconnectAction
 */
export type RemoteInterfaceAction_DisconnectAction = Message<"einride.rd_operator_interface.v1.RemoteInterfaceAction.DisconnectAction"> & {
};

/**
 * Describes the message einride.rd_operator_interface.v1.RemoteInterfaceAction.DisconnectAction.
 * Use `create(RemoteInterfaceAction_DisconnectActionSchema)` to create a new message.
 */
export const RemoteInterfaceAction_DisconnectActionSchema: GenMessage<RemoteInterfaceAction_DisconnectAction> = /*@__PURE__*/
  messageDesc(file_einride_rd_operator_interface_v1_remote_interface_action, 0, 1);

/**
 * Request to assign a path to the connected AV.
 *
 * @generated from message einride.rd_operator_interface.v1.RemoteInterfaceAction.AssignPathAction
 */
export type RemoteInterfaceAction_AssignPathAction = Message<"einride.rd_operator_interface.v1.RemoteInterfaceAction.AssignPathAction"> & {
  /**
   * The path that is to be requested to be assigned to the AV.
   *
   * @generated from field: einride.rd_operator_interface.v1.Path path = 1;
   */
  path?: Path;
};

/**
 * Describes the message einride.rd_operator_interface.v1.RemoteInterfaceAction.AssignPathAction.
 * Use `create(RemoteInterfaceAction_AssignPathActionSchema)` to create a new message.
 */
export const RemoteInterfaceAction_AssignPathActionSchema: GenMessage<RemoteInterfaceAction_AssignPathAction> = /*@__PURE__*/
  messageDesc(file_einride_rd_operator_interface_v1_remote_interface_action, 0, 2);

/**
 * Response sent by oden-supervisor to update the frontend about the status of its current operation
 * e.g. the status of the connect
 *
 * @generated from message einride.rd_operator_interface.v1.ActionResponse
 */
export type ActionResponse = Message<"einride.rd_operator_interface.v1.ActionResponse"> & {
  /**
   * Pattern: actionResponses/{actionResponse}, where {actionResponse} is a UUID.
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Timestamp when the action was sent
   *
   * @generated from field: google.protobuf.Timestamp action_time = 2;
   */
  actionTime?: Timestamp;

  /**
   * The status of the action
   *
   * @generated from oneof einride.rd_operator_interface.v1.ActionResponse.status
   */
  status: {
    /**
     * If the action is successfull
     *
     * @generated from field: einride.rd_operator_interface.v1.ActionOK ok = 3;
     */
    value: ActionOK;
    case: "ok";
  } | {
    /**
     * If the action has encountered an error
     *
     * @generated from field: einride.rd_operator_interface.v1.ActionError error = 4;
     */
    value: ActionError;
    case: "error";
  } | {
    /**
     * The action is pending
     *
     * @generated from field: einride.rd_operator_interface.v1.ActionProgress progress = 5;
     */
    value: ActionProgress;
    case: "progress";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message einride.rd_operator_interface.v1.ActionResponse.
 * Use `create(ActionResponseSchema)` to create a new message.
 */
export const ActionResponseSchema: GenMessage<ActionResponse> = /*@__PURE__*/
  messageDesc(file_einride_rd_operator_interface_v1_remote_interface_action, 1);

/**
 * Codes for actions in progress
 *
 * @generated from enum einride.rd_operator_interface.v1.ActionProgress
 */
export enum ActionProgress {
  /**
   * Default value
   *
   * @generated from enum value: ACTION_PROGRESS_UNSPECIFIED = 0;
   */
  ACTION_PROGRESS_UNSPECIFIED = 0,

  /**
   * Starting connection attempt
   *
   * @generated from enum value: STARTING_CONNECTION_ATTEMPT = 1;
   */
  STARTING_CONNECTION_ATTEMPT = 1,

  /**
   * Connecting to VPN
   *
   * @generated from enum value: CONNECTING_TO_VPN = 2;
   */
  CONNECTING_TO_VPN = 2,

  /**
   * Downloading software package
   *
   * @generated from enum value: DOWNLOADING_SOFTWARE_PACKAGE = 3;
   */
  DOWNLOADING_SOFTWARE_PACKAGE = 3,

  /**
   * Installing oden dome player
   *
   * @generated from enum value: INSTALLING_ODEN_DOME_PLAYER = 4;
   */
  INSTALLING_ODEN_DOME_PLAYER = 4,

  /**
   * Starting station software
   *
   * @generated from enum value: STARTING_STATION_SOFTWARE = 5;
   */
  STARTING_STATION_SOFTWARE = 5,

  /**
   * Connecting to vehicle
   *
   * @generated from enum value: CONNECTING_TO_VEHICLE = 6;
   */
  CONNECTING_TO_VEHICLE = 6,

  /**
   * Processing action request
   *
   * @generated from enum value: PROCESSING_ACTION = 7;
   */
  PROCESSING_ACTION = 7,
}

/**
 * Describes the enum einride.rd_operator_interface.v1.ActionProgress.
 */
export const ActionProgressSchema: GenEnum<ActionProgress> = /*@__PURE__*/
  enumDesc(file_einride_rd_operator_interface_v1_remote_interface_action, 0);

/**
 * Codes for successfull actions
 *
 * @generated from enum einride.rd_operator_interface.v1.ActionOK
 */
export enum ActionOK {
  /**
   * Default value
   *
   * @generated from enum value: ACTION_OK_UNSPECIFIED = 0;
   */
  ACTION_OK_UNSPECIFIED = 0,

  /**
   * Connect successfull
   *
   * @generated from enum value: CONNECT_SUCCESS = 1;
   */
  CONNECT_SUCCESS = 1,

  /**
   * Disconnect successfull
   *
   * @generated from enum value: DISCONNECT_SUCCESS = 2;
   */
  DISCONNECT_SUCCESS = 2,

  /**
   * Path assign successs
   *
   * @generated from enum value: PATH_ASSIGN_SUCCESS = 3;
   */
  PATH_ASSIGN_SUCCESS = 3,
}

/**
 * Describes the enum einride.rd_operator_interface.v1.ActionOK.
 */
export const ActionOKSchema: GenEnum<ActionOK> = /*@__PURE__*/
  enumDesc(file_einride_rd_operator_interface_v1_remote_interface_action, 1);

/**
 * Codes for failed actions
 *
 * @generated from enum einride.rd_operator_interface.v1.ActionError
 */
export enum ActionError {
  /**
   * Default value
   *
   * @generated from enum value: ACTION_ERROR_UNSPECIFIED = 0;
   */
  ACTION_ERROR_UNSPECIFIED = 0,

  /**
   * Action timeout
   *
   * @generated from enum value: TIMEOUT = 1;
   */
  TIMEOUT = 1,

  /**
   * VPN connection failed
   *
   * @generated from enum value: VPN_CONNECTION_FAILED = 2;
   */
  VPN_CONNECTION_FAILED = 2,

  /**
   * Software download failed
   *
   * @generated from enum value: SOFTWARE_DOWNLOAD_FAILED = 3;
   */
  SOFTWARE_DOWNLOAD_FAILED = 3,

  /**
   * Failed to install oden dome player
   *
   * @generated from enum value: ODEN_DOME_PLAYER_INSTALL_FAILED = 4;
   */
  ODEN_DOME_PLAYER_INSTALL_FAILED = 4,

  /**
   * Failed to start station software
   *
   * @generated from enum value: STATION_SOFTWARE_START_FAILED = 5;
   */
  STATION_SOFTWARE_START_FAILED = 5,

  /**
   * Station software process already running
   *
   * @generated from enum value: STATION_PROCESS_ALREADY_RUNNING = 6;
   */
  STATION_PROCESS_ALREADY_RUNNING = 6,

  /**
   * Disconnect attempt failed. Station is already disconnected.
   *
   * @generated from enum value: STATION_NOT_CONNECTED = 7;
   */
  STATION_NOT_CONNECTED = 7,

  /**
   * Incorrect requesting user
   *
   * @generated from enum value: INCORRECT_REQUESTING_USER = 8;
   */
  INCORRECT_REQUESTING_USER = 8,

  /**
   * Failed to stop action process
   *
   * @generated from enum value: STOP_STATION_PROCESSES_FAILED = 9;
   */
  STOP_STATION_PROCESSES_FAILED = 9,

  /**
   * A vehicle with the provided name was not found
   *
   * @generated from enum value: VEHICLE_NOT_FOUND = 10;
   */
  VEHICLE_NOT_FOUND = 10,
}

/**
 * Describes the enum einride.rd_operator_interface.v1.ActionError.
 */
export const ActionErrorSchema: GenEnum<ActionError> = /*@__PURE__*/
  enumDesc(file_einride_rd_operator_interface_v1_remote_interface_action, 2);

